import { API_BASE_URL } from 'api/config';
import {createAxios} from "./axios";

const formDesignApi = createAxios({
    baseURL: API_BASE_URL + '/form-designs'
});

export const fetchFormDesignById = id => {
    return formDesignApi.get(`/${id}`)
}